// extracted by mini-css-extract-plugin
export default {"active":"Tab_active__8JuVf","tab":"Tab_tab__O7rcz","tabComponent":"Tab_tabComponent__EGlGm"};